<template>
    <div class="fixed-container">
        <slot></slot>
    </div>
</template>

<script >
// 固定容器
import { use } from '@fegobull/webapi';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useTeleport
  } = use;
  !window.FEGOEditor && useTeleport(document.body);
  return {};
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.fixed-container {
    position: fixed;
    width: 7.5rem;
    z-index: 9;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
}
</style>
